import { render, staticRenderFns } from "./InputFilters.vue?vue&type=template&id=83db23f2&scoped=true&"
import script from "./InputFilters.vue?vue&type=script&lang=js&"
export * from "./InputFilters.vue?vue&type=script&lang=js&"
import style0 from "./InputFilters.vue?vue&type=style&index=0&id=83db23f2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83db23f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputCheck: require('/opt/build/repo/components/InputComponents/InputCheck.vue').default})
